'use client';

import {
  UrunlerListingGate,
  UrunlerListingNavigationProvider,
} from '@/contexts/UrunlerListingNavigationContext';
import type { ReactNode } from 'react';

export default function SearchResultsListing({
  navigationKey,
  children,
}: {
  navigationKey: string;
  children: ReactNode;
}) {
  return (
    <UrunlerListingNavigationProvider navigationKey={navigationKey}>
      <UrunlerListingGate>{children}</UrunlerListingGate>
    </UrunlerListingNavigationProvider>
  );
}
